export default __webpack_public_path__ + "static/media/qr-pdf-template-full.7941268c.png";